import type { ApiClient } from "@albertine/api-client";
import { z } from "zod";

export const LiveUpdateTopicSchema = z.object({
    name: z.string().min(1),
    id: z.string().min(1).optional(),
});

export type LiveUpdateTopic = z.infer<typeof LiveUpdateTopicSchema>;

type GetEntity = keyof ApiClient["get"];
type GetParams<K extends GetEntity> = Parameters<ApiClient["get"][K]>[0];

type GetQueryKey = {
    [K in GetEntity]: readonly [K, GetParams<K>?];
}[GetEntity];

export function getLiveUpdateTopic(
    queryKey: readonly unknown[],
): LiveUpdateTopic | undefined {
    const [entity, params] = queryKey as GetQueryKey;

    switch (entity) {
        case "request": {
            const id = params?.param.id;
            return id ? { name: "request", id } : undefined;
        }
        case "requests": {
            const id = params?.query?.memberId;
            return id ? { name: "member-requests", id } : undefined;
        }
        case "booking": {
            const id = params?.param.bookingId;
            return id ? { name: "booking", id } : undefined;
        }
        case "bookings": {
            const id = params?.query?.requestId;
            return id ? { name: "request-bookings", id } : undefined;
        }
        default:
            return undefined;
    }
}
